import React, { useState, useMemo } from "react";
import RecipeFilteredBadgeCard from "components/recipe/RecipeFilteredBadgeCard";
import BaseButton from "base/BaseButton";

const RecipeFilterByBadge = ({
  defaultAllChecked = true,
  recipes = [],
  badges,
  onFilterByBadge,
  onRecipeUpdate,
  isFilter = true,
}) => {
  // Track which badges are selected (don't mutate the original badges)
  const [selectedBadgeIds, setSelectedBadgeIds] = useState(
    defaultAllChecked ? new Set(badges.map((b) => b.id)) : new Set(),
  );

  // Sort badges alphabetically
  const sortedBadges = useMemo(() => {
    return [...badges].sort((a, b) => a.name.localeCompare(b.name));
  }, [badges]);

  // Determine if all badges are checked
  const allChecked = selectedBadgeIds.size === badges.length;

  const handleClickAll = () => {
    if (allChecked) {
      // Uncheck all
      setSelectedBadgeIds(new Set());
      if (isFilter) {
        onFilterByBadge([]);
      } else {
        onRecipeUpdate("badge_ids", new Set());
      }
    } else {
      // Check all
      setSelectedBadgeIds(new Set(badges.map((b) => b.id)));
      if (isFilter) {
        onFilterByBadge(recipes);
      } else {
        onRecipeUpdate("badge_ids", new Set(badges.map((b) => b.id)));
      }
    }
  };

  const handleChecked = (badge, isSelected) => {
    // Update selected badges
    const newSelectedIds = new Set(selectedBadgeIds);
    if (isSelected) {
      newSelectedIds.add(badge.id);
    } else {
      newSelectedIds.delete(badge.id);
    }
    setSelectedBadgeIds(newSelectedIds);
    if (isFilter) {
      // Filter recipes by selected badge IDs
      if (newSelectedIds.size === 0) {
        onFilterByBadge([]);
      } else {
        const selectedBadgeNames = badges
          .filter((b) => newSelectedIds.has(b.id))
          .map((b) => b.name);

        const filteredRecipes = recipes.filter((recipe) =>
          recipe.badges.some((b) => selectedBadgeNames.includes(b.name)),
        );
        onFilterByBadge(filteredRecipes);
      }
    } else {
      //use this to add badges to add recipe
      onRecipeUpdate("badge_ids", newSelectedIds);
    }
  };

  return (
    <div className="Column link-card-bkgrd p-1 w-100 Box-Shadow">
      <div className="Justify-Center my-4">
        <BaseButton
          buttonText={allChecked ? "Uncheck All" : "Check All"}
          handleClick={handleClickAll}
          widthClass="w-50"
        />
      </div>
      <div className="Filter-Max-Height badge-list">
        {sortedBadges.map((badge) => (
          <RecipeFilteredBadgeCard
            key={badge.id}
            badge={badge}
            isSelected={selectedBadgeIds.has(badge.id)}
            onChecked={handleChecked}
          />
        ))}
      </div>
    </div>
  );
};

export default RecipeFilterByBadge;
